import { Body, Heading, LayoutSpaceVertical, Skeleton } from 'breeze-intelligence-kit';
import { jsx as _jsx } from "react/jsx-runtime";
export const UsageBlock = ({
  children,
  isLoading
}) => /*#__PURE__*/_jsx(LayoutSpaceVertical, {
  gap: "space-xxs",
  children: /*#__PURE__*/_jsx(Skeleton, {
    blockSize: "4.25rem",
    inlineSize: "100%",
    isLoading: isLoading,
    variant: "breeze",
    children: children
  })
});
UsageBlock.Count = ({
  children
}) => /*#__PURE__*/_jsx(Body, {
  as: "div",
  children: children
});
UsageBlock.Title = ({
  children
}) => /*#__PURE__*/_jsx(Heading, {
  as: "h6",
  children: children
});